import PropTypes from 'prop-types';
// form
import { Controller, useFormContext } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  customOnChange: PropTypes.func,
  readOnly: PropTypes.bool,
  rules: PropTypes.object,
};

export default function RHFTextField({ name, customOnChange, readOnly = false, maxCharacters, dir = 'rtl', rules, ...other }) {
  const { control, watch } = useFormContext();
  const inputValue = watch(name);

  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          dir={dir}
          fullWidth
          error={!!error}
          helperText={
            <div dir="rtl" className="flex items-center justify-between w-full">
              <span>{error?.message}</span>
              {!!maxCharacters && (
                <span>
                  {inputValue?.length ?? 0} / {maxCharacters} کاراکتر
                </span>
              )}
            </div>
          }
          InputProps={{
            readOnly,
          }}
          onChange={(e) => {
            field.onChange(e);
            if (customOnChange) {
              customOnChange(e.target.value);
            }
          }}
          {...other}
        />
      )}
    />
  );
}

// error?.message || (!!maxCharacters ? `${inputValue.length}/${maxCharacters} کاراکتر` : undefined
